// src/router/index.js
// import { createRouter, createWebHashHistory } from 'vue-router';
import {createRouter, createWebHistory} from 'vue-router';

import {fileProcessorRoutes} from '@/apps/file_processor/router/index.js';

import {Storage} from '@/mechanism/storage';

import { Capacitor } from '@capacitor/core';

const currentAppId = process.env.VUE_APP_APP_ID || 'tally';

// 0. 定义登录及基础信息模块路由
const loginRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/loginIndex.vue'),
        meta: {title: '用户登录', requiresAuth: false}
    }
];

const commonRoutes = [
    {
        path: '/privacy',
        name: 'PrivacyConsent',
        component: () => import('@/views/Privacy/PrivacyConsent.vue'),
        meta: {title: '个人信息保护提示', requiresAuth: false}
    },

    {
        path: '/force-update',
        name: 'ForceUpdate',
        component: () => import('@/views/Update/ForceUpdate.vue'),
        meta: {title: '版本更新', requiresAuth: false} // false 保证无 token 也能进
    },

    {
        path: '/feedback',
        name: 'Feedback',
        component: () => import('@/components/UserFeedback/CommonFeedback.vue'),
        meta: {title: '意见反馈', requiresAuth: true}
    },


    {
        // WebView页面，用于在app内部打开链接
        path: '/webview',
        name: 'WebView',
        component: () => import('@/views/Webview/WebView.vue'),
        meta: {title: '页面详情', requiresAuth: false}
    },
];


const appRoutesMap = {
    calendar: [
        {
            path: '/calendar',
            name: 'CalendarHome',
            component: () => import('@/apps/calendar/views/CalendarHome.vue'),
            meta: {title: '我的日程', requiresAuth: true}
        },

        {
            path: '/calendar/invite/:code',
            name: 'CalendarInvite',
            component: () => import('@/apps/calendar/views/Invite/InviteLanding.vue'),
            meta: { title: '日程邀请', requiresAuth: true }
        },

        {
            path: '/calendar-account-setting',
            name: 'AccountSetting',
            component: () => import('@/apps/calendar/views/Mine/AccountSetting.vue'),
            meta: {title: '账号设置', requiresAuth: true}
        },
        {
            path: '/calendar-system-setting',
            name: 'SystemSetting',
            component: () => import('@/apps/calendar/views/Mine/SystemSetting.vue'),
            meta: {title: '系统设置', requiresAuth: true}
        },
        {
            path: '/calendar-feedback',
            name: 'Feedback',
            component: () => import('@/apps/calendar/views/Mine/UserFeedback.vue'),
            meta: {title: '意见反馈', requiresAuth: true}
        },
        {
            path: '/calendar-about-us',
            name: 'AboutUs',
            component: () => import('@/apps/calendar/views/Mine/AboutUs.vue'),
            meta: {title: '关于我们', requiresAuth: true}
        },
        {
            // 标签管理 (若暂无文件，可在 views 中建一个空白占位)
            path: '/calendar-tag-manage',
            name: 'TagManage',
            component: () => import('@/apps/calendar/views/Mine/TagManage.vue'),
            meta: {title: '分类与标签', requiresAuth: true}
        },

        {
            // 销户
            path: '/calendar-destroy-account',
            name: 'destroy',
            component: () => import('@/apps/calendar/views/Mine/DestroyAccount.vue'),
            meta: {title: '账号销户', requiresAuth: true}
        },

    ],

    admin: [
        {
            path: '/stat_parse',
            name: 'StatParse',
            // 修正路径指向 Detail 组件
            component: () => import('@/apps/system_admin/views/StatParse/OperationsDashboardView.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/templates',
            name: 'TemplateList',
            component: () => import('@/apps/system_admin/views/Template/TemplateList.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/template/edit/:id?',
            name: 'TemplateEdit',
            // 修正路径指向 Detail 组件
            component: () => import('@/apps/system_admin/views/Template/TemplateDetail.vue'),
            meta: {requiresAuth: true}
        },
        // ================= 用户反馈页面 =================
        {
            path: '/user_feedback',
            name: 'TallyUserFeedback',
            component: () => import('@/apps/system_admin/views/TallyUserFeedback/feedbackIndex.vue'),
            meta: { requiresAuth: true, title: '用户反馈管理' }
        },
        // ================= 用户信息与数据页面 =================
        {
            path: '/user_info',
            name: 'UserInfo',
            component: () => import('@/apps/system_admin/views/TallyUserInfo/tallyInfoIndex.vue'),
            meta: { requiresAuth: true, title: '用户数据详情' }
        },
    ],

    tally: [
        {
            path: '/tally',
            name: 'TallyHome',
            component: () => import('@/apps/tally/views/TallyHome.vue'),
            meta: {title: '小和记账', requiresAuth: true}
        },
        {
            path: '/account-setting',
            name: 'AccountSetting',
            component: () => import('@/apps/tally/views/Mine/AccountSetting.vue'),
            meta: {title: '账号设置', requiresAuth: true}
        },
        {
            path: '/system-setting',
            name: 'SystemSetting',
            component: () => import('@/apps/tally/views/Mine/SystemSetting.vue'),
            meta: {title: '系统设置', requiresAuth: true}
        },
        {
            path: '/about-us',
            name: 'AboutUs',
            component: () => import('@/apps/tally/views/Mine/AboutUs.vue'),
            meta: {title: '关于我们', requiresAuth: true}
        },
        {
            path: '/data-manage',
            name: 'DataManage',
            component: () => import('@/apps/tally/views/Mine/DataManage.vue'),
            meta: {title: '数据管理', requiresAuth: true}
        },
        {
            path: '/data-export',
            name: 'DataExport',
            component: () => import('@/apps/tally/views/Mine/DataExport.vue'),
            meta: {title: '导出账单数据', requiresAuth: true}
        },
        {
            // 账本管理 (若暂无文件，可在 views 中建一个空白占位)
            path: '/ledger-manage',
            name: 'LedgerManage',
            component: () => import('@/apps/tally/views/Mine/LedgerManage.vue'),
            meta: {title: '账本管理', requiresAuth: true}
        },
        {
            // 标签管理 (若暂无文件，可在 views 中建一个空白占位)
            path: '/tag-manage',
            name: 'TagManage',
            component: () => import('@/apps/tally/views/Mine/TagManage.vue'),
            meta: {title: '分类与标签', requiresAuth: true}
        },

        {
            // 销户
            path: '/tally-destroy-account',
            name: 'destroy',
            component: () => import('@/apps/tally/views/Mine/DestroyAccount.vue'),
            meta: {title: '账号销户', requiresAuth: true}
        },


        {
            path: '/tally/invite/:code',
            name: 'TallyInvite',
            component: () => import('@/apps/tally/views/Invite/InviteLanding.vue'),
            meta: { title: '账本邀请', requiresAuth: true }
        },
    ],

    assistant: [
        {
            path: '/assistant_home',
            name: 'AssistantHome',
            // 修正路径指向 Detail 组件
            component: () => import('@/apps/assistant/views/AssistantHome.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/assistant_chat',
            name: 'AssistantChat',
            // 修正路径指向 Detail 组件
            component: () => import('@/apps/assistant/views/Chat/AssistantChat.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/online_chat',
            name: 'OnlineChat',
            // 修正路径指向 Detail 组件
            component: () => import('@/apps/assistant/views/Chat/ChatOnline.vue'),
            meta: {requiresAuth: true}
        },
    ],
    file_processor: [
        {
            path: '/file-processor',
            // name: 'FileProcessorLayout',
            component: () => import('@/apps/file_processor/views/FileProcessorHome.vue'),
            meta: {title: '万能文件助手', requiresAuth: true},
            children: fileProcessorRoutes
        }
    ]


}


const activeAppRoutes = appRoutesMap[currentAppId] || [];

// 4. 合并所有路由
const routes = [
    {
        path: '/',
        redirect: process.env.VUE_APP_DEFAULT_REDIRECT || (activeAppRoutes[0] ? activeAppRoutes[0].path : '/login')
    },
    ...loginRoutes,
    ...commonRoutes,
    ...activeAppRoutes,

    {
        // 捕获所有未定义路由，重定向到首页，避免白屏
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});


router.beforeEach(async (to, from, next) => {
    if (to.meta.title) document.title = to.meta.title;

    try {
        let hasAgreedPrivacy = await Storage.get('has_agreed_privacy');

        // 🌟 1. 白名单列表：未同意隐私协议前，只允许访问这几个页面
        // 🌟 核心改造：如果是安卓端，由于原生 SplashActivity 做了物理隔离
        // 只要能走到 Vue 路由里，说明用户在原生一定点了同意，直接视为 true
        if (Capacitor.getPlatform() === 'android') {
            hasAgreedPrivacy = true;
            // 顺手同步到前端 Storage 里，保证状态一致
            await Storage.set('has_agreed_privacy', true);
        }

        const privacyWhiteList = ['/privacy', '/force-update', '/webview'];

        if (!hasAgreedPrivacy) {
            // (原逻辑保持不变：拦截非安卓端未授权用户)
            if (privacyWhiteList.includes(to.path)) {
                return next();
            }
            return next({ path: '/privacy', query: { redirect: to.fullPath }, replace: true });
        }

        // 🌟 2. 已同意隐私协议后，才执行正常的登录鉴权逻辑
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const token = await Storage.get('access_token');
        const isValid = !!token;

        if (requiresAuth && !isValid) {
            // 未登录且需要鉴权 -> 踢到登录页
            next({ path: '/login', query: { redirect: to.fullPath }, replace: true });
        } else if (to.path === '/login' && isValid) {
            // 已登录访问登录页 -> 强行拉回默认首页
            const defaultPath = process.env.VUE_APP_DEFAULT_REDIRECT || (activeAppRoutes[0] ? activeAppRoutes[0].path : '/');
            next({ path: defaultPath, replace: true });
        } else {
            // 正常放行
            next();
        }
    } catch (error) {
        console.error("路由鉴权异常:", error);
        if (to.path !== '/login' && to.path !== '/privacy' && to.path !== '/webview') {
            next({ path: '/login', query: { redirect: to.fullPath }, replace: true });
        } else {
            next();
        }
    }
});

export default router;